import { render } from "./ModalDocumentUploadFileType.vue?vue&type=template&id=3d34f238&scoped=true"
import script from "./ModalDocumentUploadFileType.vue?vue&type=script&lang=js"
export * from "./ModalDocumentUploadFileType.vue?vue&type=script&lang=js"

import "./ModalDocumentUploadFileType.vue?vue&type=style&index=0&id=3d34f238&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d34f238"]])

export default __exports__